// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Decorators
import androidOnly from '../../../components/visibility/androidOnly';
import androidKeyboardStateDecorator from './androidKeyboardStateDecorator';

// Utils
import { noLonger } from '../../../utils/react/propsComparisons';

// Actions
import { finishEditingElement } from '../../../element/selection/selectionActions';

const keyboardNoLongerVisible = noLonger('keyboardVisible');

const mapDispatchToProps = (dispatch) => ({
    dispatchStopEditing: () => dispatch(finishEditingElement()),
});

@androidOnly
@connect(null, mapDispatchToProps)
@androidKeyboardStateDecorator
class AndroidStopEditingHelper extends React.Component {
    componentWillReceiveProps(nextProps) {
        const { dispatchStopEditing } = this.props;

        if (keyboardNoLongerVisible(this.props, nextProps)) dispatchStopEditing();
    }

    render() {
        return null;
    }
}

AndroidStopEditingHelper.propTypes = {
    dispatchStopEditing: PropTypes.func,
    keyboardVisible: PropTypes.bool,
};

export default AndroidStopEditingHelper;
